import {
   ChangeDetectionStrategy,
   ChangeDetectorRef,
   Component,
   DoCheck,
   Input,
   OnDestroy,
   OnInit,
   ViewEncapsulation,
} from '@angular/core';
import { ControlContainer, FormGroupDirective, UntypedFormGroup, Validators } from '@angular/forms';
import { MatCheckbox } from '@angular/material/checkbox';
import { copyNameControlToShortNameAndDisplayName } from 'src/app/common-components/helpers/extension-form-helper';
import { ExtensionDetailView } from '../../models/extension-detail-view.model';
import { ExtensionTypeDetails } from '../../models/extension-type-details';
import { GetExtensionDetail_extension_extensionExternalForward } from '../../queries/generated/GetExtensionDetail';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-extension-external-forward-details',
    styleUrls: ['./extension-external-forward-details.component.scss'],
    templateUrl: './extension-external-forward-details.component.html',
    standalone: false
})
export class ExtensionExternalForwardDetailsComponent
   extends ExtensionTypeDetails
   implements OnInit, OnDestroy, DoCheck
{
   @Input() extension: ExtensionDetailView | null;

   @Input() extensionExternalForward: GetExtensionDetail_extension_extensionExternalForward | null;

   @Input() accountId: number | null;

   form: UntypedFormGroup;

   constructor(
      private changeDetectorRef: ChangeDetectorRef,
      private controlContainer: ControlContainer,
      private parentForm: FormGroupDirective
   ) {
      super();
   }

   ngOnDestroy(): void {
      this.extensionExternalForward = null;
   }

   ngOnInit(): void {
      this.form = <UntypedFormGroup>this.controlContainer.control;
      this.updateDtmf(this.form.get('isDtmf')?.value);
      copyNameControlToShortNameAndDisplayName(this.parentForm.form, this.form);
   }

   onIsDtmfChange(checkbox: MatCheckbox) {
      this.updateDtmf(checkbox.checked);
   }

   updateDtmf(enabled: boolean) {
      if (!this.form.disabled) {
         const dtmfControl = this.form.get('dtmf');
         const pauseSecondsControl = this.form.get('pauseSeconds');
         if (enabled) {
            dtmfControl?.enable();
            dtmfControl?.addValidators(Validators.required);
            dtmfControl?.updateValueAndValidity();
            pauseSecondsControl?.enable();
            pauseSecondsControl?.addValidators(Validators.required);
            pauseSecondsControl?.updateValueAndValidity();
         } else {
            dtmfControl?.disable();
            dtmfControl?.removeValidators(Validators.required);
            dtmfControl?.updateValueAndValidity();
            pauseSecondsControl?.disable();
            pauseSecondsControl?.removeValidators(Validators.required);
            pauseSecondsControl?.updateValueAndValidity();
         }
      }
   }

   ngDoCheck(): void {
      if (this.parentForm.form.invalid && (this.parentForm.submitted || this.form.touched)) {
         this.form.markAllAsTouched();
         this.changeDetectorRef.markForCheck();
      }
   }
}
